import { WriteOffCategory } from '@repo/types';
import { get } from 'lodash';

import { WRITEOFF_CATEGORY_LABEL, WRITEOFF_CATEGORY_CLASSES } from '../constants/writeOffs';

const useWriteOffCategory = (mode: 'dark' | 'light') => {
  const getCategoryLabel = (category: WriteOffCategory): string =>
    get(WRITEOFF_CATEGORY_LABEL, category, category);
  const getCategoryColor = (category: WriteOffCategory): string =>
    get(WRITEOFF_CATEGORY_CLASSES, `${category}.${mode}`, 'text-xtnd-dark dark:text-xtnd-light');

  return { getCategoryLabel, getCategoryColor };
};

export default useWriteOffCategory;
